import React, { useState } from 'react'
import { useTheme } from 'styled-components'
import BsGift from '@meronex/icons/bs/BsGift'

import { PurchaseGiftCard } from '../PurchaseGiftCard'
import { RedeemGiftCard } from '../RedeemGiftCard'

import {
  Container,
  TitleWrapper,
  ActionWrapper,
  Title,
  GiftCardContainer,
  Divider
} from './styles'

import { useLanguage } from '~components'
import { Modal, Button } from '~ui'

export const GiftCardUI = (props) => {
  const [, t] = useLanguage()
  const theme = useTheme()
  const [openModal, setOpenModal] = useState(null)

  return (
    <GiftCardContainer>
      <Title>
        {t('GIFT_CARD_WALLET', 'Gift Card Wallet')}
      </Title>
      <img src={theme?.images?.general?.giftCard} alt='Gift Card' />
      <div className='gift-card-content'>
        <h2>{t('GIFT_CARD_WALLET_TITLE', 'Give the gift of special moments with our Gift Cards')}</h2>
        <p>{t('GIFT_CARD_WALLET_DESCRIPTION', 'Our Gift Cards are the perfect way to surprise someone special. Whether it’s for a birthday, a celebration, or just to brighten their day, they offer flexibility and the freedom to choose what they love most. The perfect gift for any occasion!')}</p>
      </div>
      <Divider />
      <PurchaseGiftCard isPage />
      <Container>
        <TitleWrapper>
          <h1>{t('GIFT_CARD', 'Gift card')}</h1>
        <BsGift />
      </TitleWrapper>
      <ActionWrapper>
        <div className='gift-card-text'>
          <h2>{t('GOT_GIFT_CARD', 'Got a Gift Card?')}</h2>
          <p>{t('REDEEM_IT_HERE', 'Redeem it here!')}</p>
        </div>
        <Button
          color='lightGray'
          className='light'
          onClick={() => setOpenModal('redeem')}
        >
          {t('REDEEM', 'Redeem')}
        </Button>
      </ActionWrapper>
      {openModal === 'purchase' && (
        <Modal
          width='700px'
          padding='0px'
          open={openModal === 'purchase'}
          onClose={() => setOpenModal(null)}
        >
          <PurchaseGiftCard />
        </Modal>
      )}
      {openModal === 'redeem' && (
        <Modal
          width='700px'
          open={openModal === 'redeem'}
          onClose={() => setOpenModal(null)}
          padding='30px'
        >
          <RedeemGiftCard
            hideTopPlaceholders
            onClose={() => setOpenModal(null)}
          />
          </Modal>
      )}
      </Container>
    </GiftCardContainer>
  )
}
